// extracted by mini-css-extract-plugin
export default {"modal":"OO-z","modalOverlay":"PO-z","outfitHeading":"QO-z"};